export enum EventConfigEvent {
  // status
  CREATE = 'CREATE',

  PICKUP_SENT = 'PICKUP_SENT',

  FACTORY_RECEIVED = 'FACTORY_RECEIVED',
  FACTORY_STOW = 'FACTORY_STOW',
  FACTORY_PACK = 'FACTORY_PACK',

  PICKUP_RECEIVED = 'PICKUP_RECEIVED',

  FINISH = 'FINISH',

  // todo delete old statuses
  PICKUPASSIGNED = 'PICKUPASSIGNED',
  PICKUPUNASSIGNED = 'PICKUPUNASSIGNED',
  PICKUPSTARTED = 'PICKUPSTARTED',
  PICKUPDONE = 'PICKUPDONE',
  STOW = 'STOW',
  DELIVERYASKED = 'DELIVERYASKED',
  DELIVERYASSIGNED = 'DELIVERYASSIGNED',
  DELIVERYUNASSIGNED = 'DELIVERYUNASSIGNED',
  DELIVERYSTARTED = 'DELIVERYSTARTED',
  DELIVERYDONE = 'DELIVERYDONE',
  CANCEL = 'CANCEL',

  // others
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  FORGOTTEN_PASSWORD = 'FORGOTTEN_PASSWORD',
  INVOICE = 'INVOICE',
  TRANSFER_DELIVERED = 'TRANSFER_DELIVERED',
  ESTIMATED_DELIVERY_UPDATED = 'ESTIMATED_DELIVERY_UPDATED',
  SHIPPING_DELAY = 'SHIPPING_DELAY',
  SHIPPING_EXCEPTION = 'SHIPPING_EXCEPTION',
  NOSHOW_EXCEPTION = 'NOSHOW_EXCEPTION',
  NOSHOW = 'NOSHOW',
  STOW_DEADLINE = 'STOW_DEADLINE',
  STOW_DEADLINE_EXCEPTION = 'STOW_DEADLINE_EXCEPTION',
  STOW_DEADLINE_EVENT1 = 'STOW_DEADLINE_EVENT1',
  STOW_DEADLINE_EVENT2 = 'STOW_DEADLINE_EVENT2',
  FINISH_WITHOUT_PROBLEM = 'FINISH_WITHOUT_PROBLEM',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PICKUP_POINT_NOT_AVAILABLE = 'PICKUP_POINT_NOT_AVAILABLE',
}
